import type {
  EffectConfig,
  EffectParams,
  SchemaGroup,
  EffectPower,
} from '../types';
import { power, durationLong } from './baseParams';

export interface DVD extends EffectParams {
  power: EffectPower;
}

const name = 'DVD';
const groups: SchemaGroup[] = ['ongoing', 'animation'];

export const config: EffectConfig<DVD> = {
  name,
  groups,
  schema: {
    power: { ...power, default: 'soft' },
    duration: { ...durationLong, default: 8000, min: 2000 },
  },
  hide: true,
} as const;

export const responsiveConfig: EffectConfig<DVD> = {
  name,
  groups,
  schema: {
    power: { ...power, default: 'soft' },
    duration: { ...durationLong, default: 8000, min: 2000 },
  },
  hide: true,
} as const;
